export default __webpack_public_path__ + "static/media/tipsa.26a3f2bb.svg";